import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import DashboardShell from "@/components/layout/DashboardShell";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import HerGuidePublic from "@/pages/HerGuidePublic";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Guidelines from "@/pages/Guidelines";

import DashHome from "@/pages/dashboard/Home";
import DashBusiness from "@/pages/dashboard/MyBusiness";
import DashCommunity from "@/pages/dashboard/Community";
import DashEvents from "@/pages/dashboard/Events";
import DashResources from "@/pages/dashboard/Resources";
import DashCoaching from "@/pages/dashboard/Coaching";
import DashHerGuide from "@/pages/dashboard/HerGuide";
import DashBlog from "@/pages/dashboard/Blog";
import DashLeads from "@/pages/dashboard/Leads";
import DashSettings from "@/pages/dashboard/Settings";

import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Accessibility from "@/pages/legal/Accessibility";
import CookieBanner from "@/components/legal/CookieBanner";
import GlobalVipModal from "@/components/marketing/GlobalVipModal";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: check session_id during render (not useEffect) to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/her-guide" element={<HerGuidePublic />} />
      <Route path="/about" element={<About />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/guidelines" element={<Guidelines />} />

      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/accessibility" element={<Accessibility />} />

      <Route element={<ProtectedRoute><DashboardShell /></ProtectedRoute>}>
        <Route path="/dashboard" element={<DashHome />} />
        <Route path="/dashboard/business" element={<DashBusiness />} />
        <Route path="/dashboard/community" element={<DashCommunity />} />
        <Route path="/dashboard/events" element={<DashEvents />} />
        <Route path="/dashboard/resources" element={<DashResources />} />
        <Route path="/dashboard/coaching" element={<DashCoaching />} />
        <Route path="/dashboard/her-guide" element={<DashHerGuide />} />
        <Route path="/dashboard/blog" element={<DashBlog />} />
        <Route path="/dashboard/leads" element={<DashLeads />} />
        <Route path="/dashboard/settings" element={<DashSettings />} />
      </Route>
    </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <a
        href="#main"
        className="skip-link"
        data-testid="skip-to-content"
      >
        Skip to main content
      </a>
      <AuthProvider>
        <BrowserRouter>
          <main id="main" tabIndex={-1}>
            <AppRouter />
          </main>
          <CookieBanner />
          <GlobalVipModal />
          <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
